import * as i2 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { EventEmitter, Component, ChangeDetectionStrategy, Input, Output, NgModule } from '@angular/core';
import * as i3 from '@angular/router';
import { RouterModule } from '@angular/router';
import * as i4 from '@spartacus/core';
import { useFeatureStyles, I18nModule, UrlModule, FeaturesConfigModule, provideDefaultConfig, AuthGuard } from '@spartacus/core';
import * as i1 from '@spartacus/storefront';
import { ProductListItemContextSource, ProductListItemContext, AtMessageModule, ItemCounterModule, MediaModule, PageComponentModule, StarRatingModule } from '@spartacus/storefront';
import * as i1$1 from '@spartacus/cart/wish-list/root';

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const _c0 = ["cx-wish-list-item", ""];
const _c1 = a0 => ({
  cxRoute: "product",
  params: a0
});
function WishListItemComponent_div_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 13)(1, "a", 14);
    i0.ɵɵpipe(2, "cxUrl");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("routerLink", i0.ɵɵpipeBind1(2, 2, i0.ɵɵpureFunction1(4, _c1, ctx_r0.cartEntry.product)));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.cartEntry.product == null ? null : ctx_r0.cartEntry.product.name);
  }
}
function WishListItemComponent_div_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate2(" ", i0.ɵɵpipeBind1(2, 2, "cartItems.id"), " ", ctx_r0.cartEntry.product == null ? null : ctx_r0.cartEntry.product.code, " ");
  }
}
function WishListItemComponent_ng_container_8_div_1_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 19);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const variant_r2 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate2(" ", variant_r2.name, ": ", variant_r2.value, " ");
  }
}
function WishListItemComponent_ng_container_8_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 17);
    i0.ɵɵtemplate(1, WishListItemComponent_ng_container_8_div_1_div_1_Template, 2, 2, "div", 18);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const variant_r2 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", variant_r2.name && variant_r2.value);
  }
}
function WishListItemComponent_ng_container_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, WishListItemComponent_ng_container_8_div_1_Template, 2, 1, "div", 16);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r0.cartEntry.product == null ? null : ctx_r0.cartEntry.product.baseOptions[0] == null ? null : ctx_r0.cartEntry.product.baseOptions[0].selected == null ? null : ctx_r0.cartEntry.product.baseOptions[0].selected.variantOptionQualifiers);
  }
}
function WishListItemComponent_td_9_div_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 23);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.cartEntry.basePrice == null ? null : ctx_r0.cartEntry.basePrice.formattedValue, " ");
  }
}
function WishListItemComponent_td_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 20)(1, "div", 21);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, WishListItemComponent_td_9_div_4_Template, 2, 1, "div", 22);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 2, "cartItems.itemPrice"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.cartEntry.basePrice);
  }
}
function WishListItemComponent_ng_container_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0, 24);
  }
}
function WishListItemComponent_ng_template_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 25);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "addToCart.outOfStock"), " ");
  }
}
function WishListItemComponent_button_14_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 26);
    i0.ɵɵpipe(1, "cxTranslate");
    i0.ɵɵlistener("click", function WishListItemComponent_button_14_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.removeEntry(ctx_r0.cartEntry));
    });
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("cxAtMessage", i0.ɵɵpipeBind1(1, 3, "wishlist.itemRemoved"))("disabled", ctx_r0.isLoading);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 5, "common.remove"), " ");
  }
}
function WishListComponent_ng_container_0_table_1_tr_16_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tr", 11);
    i0.ɵɵpipe(1, "async");
    i0.ɵɵlistener("remove", function WishListComponent_ng_container_0_table_1_tr_16_Template_tr_remove_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.removeEntry($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const entry_r3 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("cartEntry", entry_r3)("isLoading", i0.ɵɵpipeBind1(1, 2, ctx_r1.loading$));
  }
}
function WishListComponent_ng_container_0_table_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "table", 3)(1, "caption", 4);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "thead")(5, "tr", 5)(6, "th", 6);
    i0.ɵɵtext(7);
    i0.ɵɵpipe(8, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "th", 7);
    i0.ɵɵtext(10);
    i0.ɵɵpipe(11, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "th", 8);
    i0.ɵɵtext(13);
    i0.ɵɵpipe(14, "cxTranslate");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(15, "tbody", 9);
    i0.ɵɵtemplate(16, WishListComponent_ng_container_0_table_1_tr_16_Template, 2, 4, "tr", 10);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const wishList_r4 = i0.ɵɵnextContext().ngIf;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 5, "wishlist.caption"), " ");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(8, 7, "cartItems.description"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(11, 9, "cartItems.itemPrice"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(14, 11, "cartItems.actions"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", wishList_r4 == null ? null : wishList_r4.entries);
  }
}
function WishListComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, WishListComponent_ng_container_0_table_1_Template, 17, 13, "table", 2);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const wishList_r4 = ctx.ngIf;
    i0.ɵɵnextContext();
    const emptyWishList_r5 = i0.ɵɵreference(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", (wishList_r4 == null ? null : wishList_r4.entries == null ? null : wishList_r4.entries.length) > 0)("ngIfElse", emptyWishList_r5);
  }
}
function WishListComponent_ng_template_2_p_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 14);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "wishlist.empty"), " ");
  }
}
function WishListComponent_ng_template_2_h2_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "h2");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "wishlist.empty"), " ");
  }
}
function WishListComponent_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, WishListComponent_ng_template_2_p_0_Template, 3, 3, "p", 12)(1, WishListComponent_ng_template_2_h2_1_Template, 3, 3, "h2", 13);
  }
  if (rf & 2) {
    i0.ɵɵproperty("cxFeature", "a11yEmptyWishlistHeading");
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "!a11yEmptyWishlistHeading");
  }
}
let WishListItemComponent = /*#__PURE__*/(() => {
  class WishListItemComponent {
    constructor(productListItemContextSource) {
      this.productListItemContextSource = productListItemContextSource;
      this.isLoading = false;
      this.remove = new EventEmitter();
    }
    ngOnChanges(changes) {
      if (changes?.cartEntry) {
        this.productListItemContextSource.product$.next(this.cartEntry.product);
      }
    }
    removeEntry(item) {
      this.remove.emit(item);
    }
    static {
      this.ɵfac = function WishListItemComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || WishListItemComponent)(i0.ɵɵdirectiveInject(i1.ProductListItemContextSource));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: WishListItemComponent,
        selectors: [["", "cx-wish-list-item", ""], ["cx-wish-list-item"]],
        inputs: {
          isLoading: "isLoading",
          cartEntry: "cartEntry"
        },
        outputs: {
          remove: "remove"
        },
        standalone: false,
        features: [i0.ɵɵProvidersFeature([ProductListItemContextSource, {
          provide: ProductListItemContext,
          useExisting: ProductListItemContextSource
        }]), i0.ɵɵNgOnChangesFeature],
        attrs: _c0,
        decls: 15,
        vars: 12,
        consts: [["outOfStock", ""], ["role", "cell"], [1, "cx-table-item-container"], ["tabindex", "-1", 3, "routerLink"], ["format", "thumbnail", 3, "container"], [1, "cx-info"], ["class", "cx-name", 4, "ngIf"], ["class", "cx-code", 4, "ngIf"], [4, "ngIf"], ["role", "cell", "class", "cx-price", 4, "ngIf"], ["role", "cell", 1, "cx-actions"], ["cxInnerComponentsHost", "", 4, "ngIf"], ["class", "link cx-action-link cx-remove-btn", 3, "cxAtMessage", "disabled", "click", 4, "ngIf"], [1, "cx-name"], [1, "cx-link", 3, "routerLink"], [1, "cx-code"], ["class", "cx-property", 4, "ngFor", "ngForOf"], [1, "cx-property"], ["class", "cx-label", 4, "ngIf"], [1, "cx-label"], ["role", "cell", 1, "cx-price"], [1, "cx-mobile-header"], ["class", "cx-value", 4, "ngIf"], [1, "cx-value"], ["cxInnerComponentsHost", ""], [1, "cx-out-of-stock"], [1, "link", "cx-action-link", "cx-remove-btn", 3, "click", "cxAtMessage", "disabled"]],
        template: function WishListItemComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "td", 1)(1, "div", 2)(2, "a", 3);
            i0.ɵɵpipe(3, "cxUrl");
            i0.ɵɵelement(4, "cx-media", 4);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(5, "div", 5);
            i0.ɵɵtemplate(6, WishListItemComponent_div_6_Template, 4, 6, "div", 6)(7, WishListItemComponent_div_7_Template, 3, 4, "div", 7);
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(8, WishListItemComponent_ng_container_8_Template, 2, 1, "ng-container", 8);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(9, WishListItemComponent_td_9_Template, 5, 4, "td", 9);
            i0.ɵɵelementStart(10, "td", 10);
            i0.ɵɵtemplate(11, WishListItemComponent_ng_container_11_Template, 1, 0, "ng-container", 11)(12, WishListItemComponent_ng_template_12_Template, 3, 3, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(14, WishListItemComponent_button_14_Template, 4, 7, "button", 12);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("routerLink", i0.ɵɵpipeBind1(3, 8, i0.ɵɵpureFunction1(10, _c1, ctx.cartEntry.product)));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("container", ctx.cartEntry.product == null ? null : ctx.cartEntry.product.images == null ? null : ctx.cartEntry.product.images.PRIMARY);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.cartEntry.product == null ? null : ctx.cartEntry.product.name);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.cartEntry.product == null ? null : ctx.cartEntry.product.code);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.cartEntry.product == null ? null : ctx.cartEntry.product.baseOptions == null ? null : ctx.cartEntry.product.baseOptions.length);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.cartEntry.basePrice);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.cartEntry.updateable);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngIf", ctx.cartEntry.updateable);
          }
        },
        dependencies: [i1.AtMessageDirective, i2.NgForOf, i2.NgIf, i1.MediaComponent, i1.InnerComponentsHostDirective, i3.RouterLink, i4.TranslatePipe, i4.UrlPipe],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return WishListItemComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let WishListComponent = /*#__PURE__*/(() => {
  class WishListComponent {
    constructor(wishListFacade) {
      this.wishListFacade = wishListFacade;
      this.wishList$ = this.wishListFacade.getWishList();
      this.loading$ = this.wishListFacade.getWishListLoading();
      useFeatureStyles('a11yVisibleFocusOverflows');
    }
    removeEntry(item) {
      this.wishListFacade.removeEntry(item);
    }
    static {
      this.ɵfac = function WishListComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || WishListComponent)(i0.ɵɵdirectiveInject(i1$1.WishListFacade));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: WishListComponent,
        selectors: [["cx-wish-list"]],
        standalone: false,
        decls: 4,
        vars: 3,
        consts: [["emptyWishList", ""], [4, "ngIf"], ["role", "table", 4, "ngIf", "ngIfElse"], ["role", "table"], [1, "cx-visually-hidden"], ["role", "row", 1, "cx-item-list-header", "cx-wish-list-header"], ["role", "columnheader", 1, "cx-item-list-desc"], ["role", "columnheader", 1, "cx-item-list-price"], ["role", "columnheader", 1, "cx-item-list-actions"], [1, "cx-item-list-items"], ["cx-wish-list-item", "", "role", "row", "class", "cx-item-list-row cx-wish-list-item-row", 3, "cartEntry", "isLoading", "remove", 4, "ngFor", "ngForOf"], ["cx-wish-list-item", "", "role", "row", 1, "cx-item-list-row", "cx-wish-list-item-row", 3, "remove", "cartEntry", "isLoading"], ["class", "cx-empty-wish-list", 4, "cxFeature"], [4, "cxFeature"], [1, "cx-empty-wish-list"]],
        template: function WishListComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, WishListComponent_ng_container_0_Template, 2, 2, "ng-container", 1);
            i0.ɵɵpipe(1, "async");
            i0.ɵɵtemplate(2, WishListComponent_ng_template_2_Template, 2, 2, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx.wishList$));
          }
        },
        dependencies: [i2.NgForOf, i2.NgIf, i4.FeatureDirective, WishListItemComponent, i2.AsyncPipe, i4.TranslatePipe],
        encapsulation: 2
      });
    }
  }
  return WishListComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let WishListComponentsModule = /*#__PURE__*/(() => {
  class WishListComponentsModule {
    static {
      this.ɵfac = function WishListComponentsModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || WishListComponentsModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: WishListComponentsModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        providers: [provideDefaultConfig({
          cmsComponents: {
            WishListComponent: {
              component: WishListComponent,
              data: {
                composition: {
                  inner: ['ProductAddToCartComponent']
                }
              },
              guards: [AuthGuard]
            }
          }
        })],
        imports: [AtMessageModule, CommonModule, I18nModule, ItemCounterModule, MediaModule, PageComponentModule, RouterModule, StarRatingModule, UrlModule, FeaturesConfigModule]
      });
    }
  }
  return WishListComponentsModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/**
 * Generated bundle index. Do not edit.
 */

export { WishListComponent, WishListComponentsModule, WishListItemComponent };
